import React, { useEffect, useRef, useState } from "react";
import {
  Tabs,
  Button,
  Input,
  Select,
  Form,
  Space,
  Modal,
  Avatar,
  Row,
  Col,
  Tooltip,
  Image,
} from "antd";
import {
  PlusOutlined,
  MinusCircleOutlined,
  QuestionCircleOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import UserIcon from "../../../assets/images/icons/userLogo.svg";
import { useNavigate, useLocation, Link } from "react-router-dom";
import "./index.scss";
import uuid from "react-uuid";
import OrganiationSizes from "../json/organizationSize.json";
import userServiceApi from "../../../api/userServiceApi";
import { getRequest, putRequest, postRequest } from "../../../api/http";
import { toast } from "react-toastify";
import { LoadingView } from "../../common";
import powered from "../../../assets/images/PoweredNew.png";
import { partnerName } from "../../../store/constants";

// Company Type Enum
const COMPANY_TYPES = [
  { value: "LIMITED_COMPANY", label: "Limited Company (Ltd)" },
  {
    value: "LIMITED_LIABILITY_PARTNERSHIP",
    label: "Limited Liability Partnership (LLP)",
  },
  { value: "PUBLIC_LIMITED_COMPANY", label: "Public Limited Company (PLC)" },
  {
    value: "COMMUNITY_INTEREST_COMPANY",
    label: "Community Interest Company (CIC)",
  },
  { value: "PARTNERSHIP", label: "Partnership Sole Trader" },
];

function EditOrganisation() {
  const navigate = useNavigate();
  const [organizationData, setOrganizationData] = useState({});
  const [selectedOption, setselectOption] = useState({});
  const [getFile, setFile] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [image, setImage] = useState();
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [sectors, setSectors] = useState([]);
  const [subSectors, setSubSectors] = useState({});
  const [subSectorVal, setSubSectorVal] = useState();
  const [media, setmedia] = useState({});
  const [countries, setCountries] = useState([]);
  const [activeKey, setActiveKey] = useState("personalDetailsTab");
  const [profile, setProfile] = useState();
  const [showRegistrationNumber, setShowRegistrationNumber] = useState(true);
  const [form] = Form.useForm();
  const { state } = useLocation() || {};
  const [startDate, setStartDate] = useState(new Date());
  const isInitialRender = useRef(true);
  const [partnerDatas, setPartnerDatas] = useState({});
  const [originalRegistrationNumber, setOriginalRegistrationNumber] =
    useState(null);

  const partner = localStorage.getItem("partner");
  const partnerID = localStorage.getItem("partnerID");

    const [companyTypes, setCompanyTypes] = useState([]);


  localStorage.setItem("page", "edit");

const [limitedCompanyId, setLimitedCompanyId] = useState(null);

// Add this function
const fetchCompanyTypes = async () => {
  try {
    setLoading(true);
    const headers = {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    };
    const response = await getRequest(
      userServiceApi.getMasterDataType("COMPANY_TYPE"),
      { headers }
    );
    
    setCompanyTypes(response.data);
    
    // Find and store the Limited Company ID for comparison
    const limitedCompany = response.data.find(
      (type) => type.value === "Limited Company (Ltd)"
    );
    if (limitedCompany) {
      setLimitedCompanyId(limitedCompany.id);
    }
    
    setLoading(false);
  } catch (error) {
    toast.error(error.error);
    setLoading(false);
  }
};

useEffect(() => {
  fetchSectorList();
  fetchCountryList();
  fetchOrganization();
  fetchAdminProfile();
  fetchCompanyTypes(); // ADD THIS LINE
}, []);

useEffect(() => {
  // Check if we have both the organization data and the limited company ID
if (organizationData?.companyType?.id && limitedCompanyId) {
  const selectedId = organizationData.companyType.id;
  const isLimitedCompany = selectedId === limitedCompanyId;
  setShowRegistrationNumber(isLimitedCompany);
}

}, [organizationData?.companyType, limitedCompanyId]);


const checkPartnerstatus = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await fetch(userServiceApi.checkPartnerstatus(token), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // optional, depends on your API
        },
      });

      // Try to parse JSON safely
      let data;
      try {
        data = await response.json();
      } catch {
        data = {};
      }
      if (response.status === 400) {
        toast.error(data?.error || "Access denied");
        localStorage.clear();
        navigate(`/login/${partnerID}`, { replace: true });
        return;
      }

      if (!response.ok) {
        toast.error(data?.message || "Something went wrong");
      }

    } catch (error) {
      toast.error("Network error. Please try again later.");
    }
  };
  
  useEffect(() => {
    checkPartnerstatus()
  }, []);

  // useEffect(() => {
  //   if (organizationData?.name) {
  //     localStorage.setItem("OrgNames", organizationData.name);
  //   }
  // }, [organizationData, localStorage.getItem("OrgNames")]);

  const getPartnerDetailsData = async (partner) => {
    try {
      // setLoading(true);
      const response = await getRequest(
        // userServiceApi.getPartnerDetailsLoginScreen(partnerID)
        userServiceApi.getPartnerDetailsLoginScreen(partnerName)

      );

      if (response && response.data) {
        setPartnerDatas(response.data);
      }
    } catch (error) {
      // toast.error(error.error);
    }
  };

  useEffect(() => {
  }, [organizationData]);

  useEffect(() => {
  }, [showRegistrationNumber]);

useEffect(() => {
  // organizationData.companyType is the enum value like "LIMITED_COMPANY"
  const companyTypeValue = organizationData?.companyType;

  if (companyTypeValue === "LIMITED_COMPANY") {
    // setShowRegistrationNumber(true);
  } else {
    // setShowRegistrationNumber(false);
  }
}, [organizationData]);

  useEffect(() => {
    setTimeout(() => {
      getPartnerDetailsData(partner);
    }, 1000);
  }, []);

  useEffect(() => {
    if (state && state?.tab) {
      setActiveKey(state.tab);
    }
  }, [state]);

  const fetchSectorList = async () => {
    try {
      setLoading(true);
      const headers = {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      };
      const response = await getRequest(
        userServiceApi.getAllSectors(partnerID),
        {
          headers,
        }
      );
      setSectors(response.data);
      setLoading(false);
    } catch (error) {
      toast.error(error.error);
      setLoading(false);
    }
  };

  const fetchCountryList = async () => {
    try {
      setLoading(true);
      const response = await getRequest(userServiceApi.getAllCountries());
      setCountries(response.data);
      setLoading(false);
    } catch (error) {
      toast.error(error.error);
      setLoading(false);
    }
  };

  const fetchOrganization = async () => {
    try {
      setLoading(true);
      const headers = {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      };
      const response = await getRequest(
        userServiceApi.getSingleOrganization(),
        { headers }
      );

      if (response && response.data) {
        form.resetFields();
        setOrganizationData(response.data);
        const resData = response.data;

        // 🧩 Update form fields immediately when organization data loads
        form.setFieldsValue({
          companyType: resData.companyType,
          companyRegistrationNumber: resData.companyRegistrationNumber,
          name: resData.name,
          size: resData.size,
          addressOutputs: resData.addressOutputs || [""],
          sectorsOutputs: Array.isArray(resData.sectorsOutputs)
          ? resData.sectorsOutputs
          : resData.sectorsOutputs
          ? [resData.sectorsOutputs]
          : [""],

        });


        // Store the original registration number
        setOriginalRegistrationNumber(
          resData.companyRegistrationNumber || null
        );

        if (resData.sectorsOutputs && !Array.isArray(resData.sectorsOutputs)) {
          resData.sectorsOutputs = [resData.sectorsOutputs];
        }

        if (resData.addressOutputs && !Array.isArray(resData.addressOutputs)) {
          resData.addressOutputs = [resData.addressOutputs];
        }

        if (
          resData.sectorsOutputs &&
          resData.sectorsOutputs.length > 0 &&
          resData.sectorsOutputs[0].sectorOutput?.id
        ) {
          sectorChange(resData.sectorsOutputs[0].sectorOutput.id, 0);

        }

        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      toast.error(error.error);
      setLoading(false);
    }
  };

  const fetchAdminProfile = async () => {
    try {
      setLoader(true);
      const headers = {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      };
      const response = await getRequest(userServiceApi.getProfile(), {
        headers,
      });

      if (response.data) {
        setProfile(response.data);
        setLoader(false);
      }
    } catch (error) {
      toast.error(error.error);
      setLoading(false);
    }
  };

  const changeTab = (tabValue) => {
    if (tabValue === "organizationDetailsTab") {
      navigate("/edit-organization", {
        state: { tab: "organizationDetailsTab" },
      });
    } else {
      navigate("/edit-organization", { state: { tab: "personalDetailsTab" } });
    }
  };

  const sectorChange = async (sectorId, i) => {
    
    setSubSectorVal(null);

    setselectOption((prev) => {
      prev[i] = sectorId;
      return { ...prev };
    });
    
    try {
      const headers = {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      };
      
      const response = await getRequest(
        userServiceApi.getSubSectors(sectorId),
        { headers }
      );

      setSubSectors((prev) => {
        prev[sectorId] = response.data;
        return { ...prev };
      });

      
      if (!isInitialRender.current) {
        const currentFieldValues = form.getFieldsValue();
        
        const updatedSectorsOutputs = currentFieldValues.sectorsOutputs.map((output, index) => {
          if (index === i) {
            const updated = { ...output, subSectorOutput: { id: null } };
            return updated;
          }
          return output;
        });
        
        
        form.setFieldsValue({
          sectorsOutputs: updatedSectorsOutputs
        });
        
      } else {
        isInitialRender.current = false;
      }

      if (response) {
        form.setFieldValue(["sectorsOutputs", "subSectorOutput", "id"], "");
      }
      
      
    } catch (error) {
      toast.error(error.error);
    }
  };

const handleCompanyTypeChange = (selectedId) => {
  // selectedId is the UUID from the API
  const isLimitedCompany = selectedId === limitedCompanyId;
  setShowRegistrationNumber(isLimitedCompany);

  if (isLimitedCompany) {
    // Restore original registration number
    form.setFieldsValue({
      companyRegistrationNumber: originalRegistrationNumber,
    });
  } else {
    // Clear the field when not Limited Company
    form.setFieldsValue({
      companyRegistrationNumber: null,
    });
  }
};


  const changeHandler = (event) => {
    if (event.target.files && event.target.files[0].size >= 2e6) {
      toast.error("File should not exceed 2MB");
    } else {
      setImage(event.target.files[0]);
      let unique_ID = uuid();
      var file = event.target.files[0].name;
      var FT = event.target.files[0].type;
      var fSize = event.target.files[0].size;
      var fileArray = file.split(".");
      var fileExt = fileArray[fileArray.length - 1];
      var fileName = file.split(".").slice(0, -1).join(".");
      var fileType = FT.substr(0, FT.lastIndexOf("/"));
      const items = {
        mediaType: fileType === "image" ? "IMAGE" : null,
        mediaProperty: {
          id: unique_ID,
          name: fileName,
          extension: fileExt,
        },
      };
      setmedia({ ...items });
      var image = event.target.files[0];
      var blob = image.slice(0, image.size);
      const newFile = new File([blob], `${unique_ID}_${fileName}.${fileExt}`, {
        type: `${image.type}`,
      });
      setFile(newFile);

      const fields = form.getFieldsValue(true);
      form.resetFields();
      form.setFieldsValue({ ...fields });
    }
  };

  const onFinish = async (values) => {

      if (values.companyType && typeof values.companyType === "object") {
    values.companyType = values.companyType.id;
  }

  if (values.companyType !== limitedCompanyId) {
    values.companyRegistrationNumber = null;
  }

if (!Array.isArray(values.sectorsOutputs)) {
  values.sectorsOutputs = values.sectorsOutputs
    ? [values.sectorsOutputs]
    : [];
}



    if (activeKey === "personalDetailsTab") {
      let submit = { ...values };

      try {
        const headers = {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        };
        const response = await putRequest(
          userServiceApi.updateProfile(),
          submit,
          {
            headers,
          }
        );
        if (response) {
          toast.success("Organisation Updated Successfully");
          navigate(`/`);
        }
      } catch (error) {
        toast.error(error.error);
      }
    } else {
      let addressArray = [];
      let sectorArray = {};
      values.sectorsOutputs.map((ddd) => {
        sectorArray = {
          sectorId: ddd.sectorOutput.id,
          subSectorId: ddd.subSectorOutput.id,
        };
      });

      values.addressOutputs.map((address) => {
        addressArray.push({
          street: address.street?.replace(/(\r\n|\n|\r)/g, " "),
          countryId: address.countryOutput.id,
          postalCode: address.postalCode,
        });
      });

      if (getFile) {
        let submit = {
          ...values,
          addressInputs: addressArray,
          sectorsInputs: sectorArray,
          media: media,
        };
        delete submit.addressOutputs;
        delete submit.sectorsOutputs;

        const json = JSON.stringify(submit);
        const blob = new Blob([json], {
          type: "application/json",
        });

        var formData = new FormData();
        formData.append("organizationInput", blob);
        formData.append("media", getFile);
        try {
          const headers = {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          };
          const response = await putRequest(
            userServiceApi.updateOrganization(),
            formData,
            { headers: { "Content-Type": "multipart/form-data" }, headers }
          );

          if (response) {
            if (response.name) {
              localStorage.setItem("OrgName", response.name);
            }
            if (response.mediaLink) {
              localStorage.setItem("OrgImage", response.mediaLink);
            }
            if ("isOrganizationProfilePending" in response) {
              localStorage.setItem(
                "isOrganizationProfilePending",
                response.isOrganizationProfilePending
              );
            }
            toast.success("Organization Updated Successfully");
            navigate("/");
          }
        } catch (error) {
          toast.error(error.error);
        }
      } else {
        let submit = {
          ...values,
          addressInputs: addressArray,
          sectorsInputs: sectorArray,
        };
        delete submit.addressOutputs;
        delete submit.sectorsOutputs;

        const json = JSON.stringify(submit);
        const blob = new Blob([json], {
          type: "application/json",
        });

        var formData = new FormData();
        formData.append("organizationInput", blob);
        try {
          const headers = {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          };
          const response = await putRequest(
            userServiceApi.updateOrganization(),
            formData,
            { headers: { "Content-Type": "multipart/form-data" }, headers }
          );
          if (response) {
            if (response.name) {
              localStorage.setItem("OrgName", response.name);
            }
            if ("isOrganizationProfilePending" in response) {
              localStorage.setItem(
                "isOrganizationProfilePending",
                response.isOrganizationProfilePending
              );
            }
            if (response.mediaLink) {
              localStorage.setItem("OrgImage", response.mediaLink);
            }
            toast.success("Organization Updated Successfully");
            navigate("/");
          }
        } catch (error) {
          toast.error(error.error);
        }
      }
    }
  };

  const onFinishFailed = (errorInfo) => {
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const createMicreosite = () => {
    navigate("/");
  };

  if (
    loading ||
    !(organizationData && organizationData.id && organizationData.name) ||
    !(profile && profile.userName)
  ) {
    return <LoadingView message="Loading..." />;
  }

  return (
    <>
      <React.Fragment>
        <div className="tabContainer" style={{ minHeight: "50vh" }}>
          <Form
            name="control-hooks"
            className="organizationForm"
            labelCol={{
              span: 6,
            }}
            wrapperCol={{
              span: 10,
            }}
            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            initialValues={
              organizationData && organizationData.id && organizationData.name
                ? {
                  type: organizationData && organizationData.type,
                  name:
                    organizationData && organizationData.name
                      ? organizationData.name
                      : "",
                  size: organizationData && organizationData.size,
                  media: organizationData && organizationData.media,
                  companyType:
                    organizationData && organizationData.companyType,
                  companyRegistrationNumber:
                    organizationData &&
                    organizationData.companyRegistrationNumber,
                  country:
                    organizationData &&
                      organizationData.addressOutputs.length > 0
                      ? organizationData &&
                      organizationData.addressOutputs[0].countryOutput
                      : "",
                  mediaLink: organizationData && organizationData.mediaLink,
                  addressOutputs:
                    organizationData &&
                      organizationData.addressOutputs.length > 0
                      ? organizationData && organizationData.addressOutputs
                      : [""],

                  
                  sectorsOutputs:
                    organizationData &&
                      organizationData.sectorsOutputs.length > 0
                      ? organizationData && organizationData.sectorsOutputs
                      : [""],


                  userName:
                    profile && profile.userName ? profile.userName : "",
                  email: profile && profile.email ? profile.email : "",
                  phoneNumber:
                    profile && profile.phoneNumber ? profile.phoneNumber : "",
                }
                : {
                  addressOutputs: [""],
                  sectorsOutputs: [""],
                  firstName:
                    profile && profile.firstName ? profile.firstName : "",
                  lastName:
                    profile && profile.lastName ? profile.lastName : "",
                }
            }
            
          >
            <div className="buttons">
              <Button
                className="cancelBtn"
                onClick={() => {
                  navigate("/");
                }}
                disabled={
                  organizationData &&
                    organizationData.isOrganizationProfilePending === true
                    ? true
                    : false
                }
              >
                Cancel
              </Button>
              <Button className="greenBtn" htmlType="submit" dis>
                Save
              </Button>
            </div>

            <Tabs onChange={changeTab} activeKey={activeKey}>
              <Tabs.TabPane tab="Personal Details" key="personalDetailsTab">
                {activeKey === "personalDetailsTab" ? (
                  <>
                    <Row
                      className="rowBody"
                      gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                    >
                      <Col className="gutter-row tabContent" span={15}>
                        <Form.Item
                          rules={[
                            {
                              required: true,
                              message: "Full Name is required",
                            },{ max: 50, message: "Full name cannot exceed 50 characters" },
                          ]}
                          label="Full Name"
                          name="userName"
                        >
                          <Input />
                        </Form.Item>
                        <Form.Item
                    normalize={(value) => value?.trim()}
                          rules={[
                            {
                              required: true,
                              message: "Email is required",
                            },
                          ]}
                          label="Email"
                          name="email"
                        >
                          <Input disabled />
                        </Form.Item>
                        <Form.Item
                          rules={[
                            {
                              required: true,
                              message: "Phone number is required",
                            },
                          ]}
                          label="Phone Number"
                          name="phoneNumber"
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                ) : (
                  <></>
                )}
              </Tabs.TabPane>

              <Tabs.TabPane
                tab="Organisation Details"
                key="organizationDetailsTab"
              >
                {activeKey === "organizationDetailsTab" ? (
                  <>
                    <Row
                      className="rowBody"
                      gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                    >
                      <Col className="gutter-row tabContent" span={15}>
                        <Form.Item
                          name="type"
                          label="Organisation type"
                          rules={[
                            {
                              required: true,
                              message: "Organisation type is required",
                            },
                          ]}
                        >
                          <Select placeholder="Select Option" disabled>
                            {partnerDatas?.organizationTypes?.length > 0
                              ? partnerDatas?.organizationTypes.map(
                                (OrganiationType, i) => (
                                  <Select.Option
                                    key={i}
                                    value={OrganiationType}
                                  >
                                    {OrganiationType}
                                  </Select.Option>
                                )
                              )
                              : null}
                          </Select>
                        </Form.Item>
                        <div className="remove-btn">
                          <Tooltip
                            title={
                              "To edit name and type of organization please send a request mail to partner.connectsu@gmail.com"
                            }
                          >
                            <QuestionCircleOutlined />
                          </Tooltip>
                        </div>
                      </Col>
                      <Col className="gutter-row tabContent" span={15}>
                        <Form.Item
                          rules={[
                            {
                              required: true,
                              message: "Organisation Name is required",
                            },
                          ]}
                          label="Organisation name"
                          name="name"
                        >
                          <Input disabled />
                        </Form.Item>
                      </Col>

                      <Col className="gutter-row tabContent" span={15}>
                        <Form.Item
                          label={
                            <div className="ant-form-item-label ">
                              <label
                                htmlFor="media"
                                className="ant-form-item-required"
                                title="Organisation logo"
                              >
                                Organisation logo
                              </label>
                            </div>
                          }
                          colon={false}
                          name="media"
                          className="experienceImg noPadding uploadedImage"
                          rules={[
                            {
                              validator: (_, value) => {
                                if (getFile) {
                                  return Promise.resolve();
                                } else if (organizationData.mediaLink) {
                                  return Promise.resolve();
                                } else {
                                  return Promise.reject(
                                    new Error("Image is required")
                                  );
                                }
                              },
                            },
                          ]}
                        >
                          <div className="d-flex">
                            <Tooltip
                              title={"Upload image with size lesser than 2MB"}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {organizationData.mediaLink ? (
                                  getFile ? (
                                    <Image
                                      src={
                                        getFile
                                          ? URL.createObjectURL(getFile)
                                          : null
                                      }
                                      alt={getFile ? getFile.name : null}
                                    />
                                  ) : (
                                    <Image
                                      src={organizationData.mediaLink}
                                      alt=""
                                    />
                                  )
                                ) : image === undefined ? (
                                  <Image src={UserIcon} alt="" />
                                ) : (
                                  <Image
                                    src={
                                      getFile
                                        ? URL.createObjectURL(getFile)
                                        : null
                                    }
                                    alt={getFile ? getFile.name : null}
                                  />
                                )}
                                <label className="fileUploadBtn greenBtn">
                                  {" "}
                                  Choose File
                                  <input onChange={changeHandler} type="file" />
                                </label>
                              </div>
                            </Tooltip>
                          </div>
                        </Form.Item>
                        <Form.Item
                          name="size"
                          label="Size by employees"
                          rules={[
                            {
                              required: true,
                              message: "Organisation size is required",
                            },
                          ]}
                        >
                          <Select placeholder="Select Option">
                            {OrganiationSizes.map((OrganiationSize, i) => (
                              <Select.Option key={i} value={OrganiationSize.id}>
                                {OrganiationSize.name}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>

                        <Form.List name="addressOutputs">
                          {(fields, { add, remove }) => (
                            <>
                              {fields.map(({ key, name, ...restField }, i) => (
                                <Space
                                  key={key}
                                  style={{
                                    display: "block",
                                    marginBottom: 8,
                                  }}
                                  align="baseline"
                                >
                                  <div
                                    className="fullAddress"
                                    style={{
                                      position: "relative",
                                      display: "flex",
                                      alignItems: "center",
                                      left: 0,
                                    }}
                                  >
                                    <Form.Item
                                      className="address-form w-100 noPadding"
                                      colon={false}
                                      label={
                                        <div className="ant-form-item-label">
                                          <label
                                            className="ant-form-item-required"
                                            title="Address"
                                            colon={false}
                                          >
                                            Full address including <br /> postal
                                            code:
                                          </label>
                                        </div>
                                      }
                                    >
                                      <Form.Item
                                        {...restField}
                                        name={[name, "street"]}
                                        rules={[
                                          {
                                            required: true,
                                            message: "Address is required",
                                          },
                                        ]}
                                        style={{
                                          width: "100%",
                                          marginBottom: 0,
                                        }}
                                      >
                                        <Input.TextArea rows={4} />
                                      </Form.Item>

                                      {fields.length > 1 && i !== 0 ? (
                                        <DeleteOutlined
                                          style={{ marginLeft: "10px" }}
                                          onClick={() => remove(i)}
                                        />
                                      ) : null}
                                    </Form.Item>
                                    <div className="remove-btn">
                                      <Tooltip
                                        title={
                                          "This address will not be displayed as the organization's location on the map. To update the map location, please edit the address in the Contact Us tab of the respective microsite."
                                        }
                                      >
                                        <QuestionCircleOutlined />
                                      </Tooltip>
                                    </div>
                                  </div>
                                  <Form.Item
                                    label="Country"
                                    {...restField}
                                    name={[name, "countryOutput", "id"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Country is required",
                                      },
                                    ]}
                                  >
                                    <Select placeholder="Select Option">
                                      {countries.map((country, i) => (
                                        <Select.Option
                                          key={i}
                                          value={country.id}
                                        >
                                          {country.name}
                                        </Select.Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </Space>
                              ))}

                              {/* <div className="inputBody">
                                <label></label>
                                <div className="addAddressBtn">
                                  <Button
                                    className="greenBtn"
                                    onClick={() => add()}
                                  >
                                    Add additional address
                                    <PlusOutlined />
                                  </Button>
                                </div>
                              </div> */}
                            </>
                          )}
                        </Form.List>

                        <Form.List name="sectorsOutputs">
                          {(fields, { add, remove }) => (
                            <>
                              {fields.map(({ key, name, ...restField }, i) => (
                                <Space
                                  key={key}
                                  style={{
                                    display: "block",
                                    marginBottom: 8,
                                  }}
                                  align="baseline"
                                >
                                  <Form.Item
                                    className="noPadding"
                                    label={
                                      <div className="ant-form-item-label">
                                        <label
                                          className="ant-form-item-required"
                                          title="Address"
                                        >
                                          Categories
                                        </label>
                                      </div>
                                    }
                                    colon={false}
                                  >
                                    <Form.Item
                                      noStyle
                                      {...restField}
                                      name={[name, "sectorOutput", "id"]}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Categories is required",
                                        },
                                      ]}
                                    >
                                      <Select
                                        onChange={(e) => sectorChange(e, i)}
                                        placeholder="Select Option"
                                      >
                                        {sectors?.map((Sector, i) => (
                                          <Select.Option
                                            key={i}
                                            value={Sector?.id}
                                          >
                                            {Sector?.name}
                                          </Select.Option>
                                        ))}
                                      </Select>
                                    </Form.Item>

                                    {fields?.length > 1 && i !== 0 ? (
                                      <Button
                                        style={{ marginLeft: "10px" }}
                                        onClick={() => remove(i)}
                                        icon={<MinusCircleOutlined />}
                                      ></Button>
                                    ) : null}
                                  </Form.Item>

                                  <Form.Item
                                    label="Sub categories"
                                    {...restField}
                                    name={[name, "subSectorOutput", "id"]}
                                    
                                    rules={[
                                      {
                                        required: true,
                                        message: "Sub categories is required",
                                      },
                                    ]}
                                  >
                                    <Select
                                      value={subSectorVal}
                                      
                                      
                                      disabled={
                                        i in selectedOption
                                          ? false
                                          : form.getFieldValue([
                                            "sectorsOutputs",
                                            i,
                                            "sectorOutput",
                                            "id",
                                          ])
                                            ? false
                                            : true
                                      }
                                      placeholder="Select Option"
                                    >
                                      
                                      
                                      {subSectors &&
                                        subSectors[
                                        form.getFieldValue([
                                          "sectorsOutputs",
                                          i,
                                          "sectorOutput",
                                          "id",
                                        ])
                                        ] &&
                                        subSectors[
                                          form.getFieldValue([
                                            "sectorsOutputs",
                                            i,
                                            "sectorOutput",
                                            "id",
                                          ])
                                        ]?.map((subSector, i) => (
                                          <Select.Option
                                            key={i}
                                            value={subSector.id}
                                          >
                                            {subSector.name}
                                          </Select.Option>
                                        ))}
                                    </Select>
                                  </Form.Item>
                                </Space>
                              ))}
                            </>
                          )}
                        </Form.List>
                      </Col>

<Col className="gutter-row tabContent" span={15}>
  <Form.Item
    name="companyType"
    label="Company Type"
    rules={[
      {
        required: true,
        message: "Company Type is required",
      },
    ]}
  >
    <Select
      placeholder="Select Company Type"
      onChange={handleCompanyTypeChange}
    >
      {companyTypes.map((type) => (
        <Select.Option key={type.id} value={type.id}>
          {type.value}
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
</Col>



{showRegistrationNumber && (
  <Col className="gutter-row tabContent" span={15}>
    <Form.Item
      name="companyRegistrationNumber"
      label="Company Registration Number"
      rules={[
        {
          required: showRegistrationNumber,
          message: "Company Registration Number is required",
        },
      ]}
    >
      <Input placeholder="Enter Company Registration Number" />
    </Form.Item>
  </Col>
)}

                    </Row>
                  </>
                ) : (
                  <></>
                )}
              </Tabs.TabPane>
            </Tabs>
          </Form>
        </div>
        <div className="footerlogo">
          <img
            style={{ cursor: "pointer", width: "100px", marginBottom: "5px" }}
            src={powered}
            alt=""
          />
        </div>
        <Modal
          open={isModalOpen}
          footer={null}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          <div className="modalBody">
            <h3>Organization created successfully</h3>
            <h3>You are ready to create the Microsite</h3>
            <Button onClick={() => createMicreosite()} className="greenBtn">
              Create Microsite
            </Button>
          </div>
        </Modal>
      </React.Fragment>
    </>
  );
}

export default EditOrganisation;
